import React, { useLayoutEffect, useRef } from 'react';

interface IndicesHorizontalViewportProps {
  children: React.ReactNode;
  resetKey: string;
  ariaLabel?: string;
}

const IndicesHorizontalViewport: React.FC<IndicesHorizontalViewportProps> = ({
  children,
  resetKey,
  ariaLabel = 'マーケット指標カード一覧',
}) => {
  const viewportRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (viewportRef.current) {
      viewportRef.current.scrollLeft = 0;
    }
  }, [resetKey]);

  return (
    <div className="indices-horizontal-scroll" data-reset-key={resetKey}>
      <div
        ref={viewportRef}
        className="indices-horizontal-scroll__viewport"
        role="region"
        aria-label={ariaLabel}
      >
        {children}
      </div>
    </div>
  );
};

export default IndicesHorizontalViewport;
